import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const SenecaCollege = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Seneca College"
      universityShortName="Seneca"
      slug="seneca-college"
      seoTitle="Seneca College Study Rooms | Newnham, King & Seneca@York Campus Guide"
      seoDescription="Complete guide to study rooms at Seneca College. Find library study spaces at Newnham, King and Seneca@York campuses. Plus free 24/7 online alternative."
      seoKeywords="seneca college study rooms, seneca library, newnham campus study, seneca at york, king campus library, seneca study spaces"
      canonicalUrl="/study-room/seneca-college/"
      heroDescription="A comprehensive guide to study rooms and spaces at Seneca College's Newnham, King and Seneca@York campuses."
      libraryWebsiteUrl="https://library.senecacollege.ca/"
      libraryWebsiteName="Seneca Libraries"
      studySpaces={[
        {
          name: "Campus Libraries (All Locations)",
          features: "Every campus library has quiet study areas, and library staff can help students locate them or reserve a study room for group work.",
          feedback: "The booking system is not widely advertised, so some students are unaware of how to reserve rooms."
        },
        {
          name: "Group Study Rooms",
          features: "Group rooms can be reserved through the library's booking system. Spaces are designed for collaboration and may include screens or media equipment.",
          feedback: "Students on the Seneca subreddit complain that the Seneca@York library is 'shitty'; couches are occupied by loud groups, study rooms are always booked, and there are few washrooms."
        },
        {
          name: "Media Pods",
          features: "Technology-equipped pods for multimedia work and group collaboration.",
          feedback: "Popular with students working on media projects."
        },
        {
          name: "Quiet Study Areas",
          features: "Designated quiet zones in each campus library for focused individual study.",
          feedback: "Quality varies by campus; some are quieter than others."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Seneca's libraries promise quiet study zones and bookable group rooms, but <strong>your experience may vary by campus</strong>. At <strong>Seneca@York</strong>, avoid the library couches if you value silence—students describe the area as loud and perpetually occupied.
          </p>
          <p className="mb-4">
            <strong>Booking a study room is essential</strong>, and you should do so early. If all rooms are booked or you need to attend an online lecture, look for hidden spots in academic buildings (e.g., the K-building at Newnham) and always carry headphones.
          </p>
          <p>
            Once you secure a room, the spaces are functional and allow small groups to collaborate without disturbing others. The lack of washrooms near some libraries is an annoyance, so plan your breaks accordingly.
          </p>
        </>
      }
      summaryTips={[
        "Book study rooms early: Group rooms fill up fast, especially at busier campuses like Seneca@York.",
        "Avoid library couches: Common lounge areas tend to be loud with socializing students.",
        "Explore academic buildings: Hidden spots in buildings like K-building at Newnham can offer quieter alternatives.",
        "Always bring headphones: Noise levels are inconsistent across Seneca campuses.",
        "Use CSW for reliable quiet: Virtual study rooms offer consistent, distraction-free studying when campus spaces disappoint."
      ]}
    />
  );
};

export default SenecaCollege;
